import { render } from "./ChatbotWrapper.vue?vue&type=template&id=4a2f00ec&scoped=true&ts=true"
import script from "./ChatbotWrapper.vue?vue&type=script&lang=ts"
export * from "./ChatbotWrapper.vue?vue&type=script&lang=ts"

import "./ChatbotWrapper.vue?vue&type=style&index=0&id=4a2f00ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2f00ec"]])

export default __exports__